<script lang="ts">
  import { push } from 'svelte-spa-router';
  import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardActions,
    CardTitle,
  } from 'svelte-materialify';
  import { projectConfigs } from '../../store';
  import Header from '../Header.svelte';

  function navigateToProject(key: string) {
    push(`/project/${key}/reports`);
  }
</script>

<Header />
<Container class="page-inner">
  <Row>
    {#each $projectConfigs as project}
      <Col cols={6}>
        <Card outlined>
          <CardTitle>{project.name}</CardTitle>
          <CardActions>
            <Button on:click={() => navigateToProject(project.key)} rounded outlined
              >Open</Button
            >
          </CardActions>
        </Card>
      </Col>
    {/each}
  </Row>
</Container>
